import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMessenger = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M8 0.5C3.8645 0.5 0.5 3.6965 0.5 7.625C0.5 9.53375 1.316 11.366 2.75 12.704V14.747C2.75 15.3057 3.338 15.6695 3.8375 15.4198L5.80925 14.4342C6.52925 14.6435 7.265 14.75 8 14.75C12.1355 14.75 15.5 11.5535 15.5 7.625C15.5 3.6965 12.1355 0.5 8 0.5ZM8.351 9.3935L6.6875 8.063L2.75 9.81275L6.65 5.91275C6.92 5.64275 7.3505 5.61875 7.649 5.85725L9.3125 7.18775L13.25 5.43725L9.35 9.33725C9.07925 9.608 8.6495 9.632 8.351 9.3935Z",
			fill: "url(#paint0_linear_3998_46794)"
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint0_linear_3998_46794",
			x1: 8,
			y1: .5,
			x2: 8,
			y2: 15.5,
			gradientUnits: "userSpaceOnUse",
			children: [
				/* @__PURE__ */ _jsx("stop", { stopColor: "#FF5E73" }),
				/* @__PURE__ */ _jsx("stop", {
					offset: .510417,
					stopColor: "#894BFF"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#0094FF"
				})
			]
		}) })
	]
});
const ForwardRef = forwardRef(SvgMessenger);
export { ForwardRef as ReactComponent };
